<mat-expansion-panel
  [expanded]="expanded"
  (closed)="saveExpandedState(false)"
  (opened)="saveExpandedState(true)"
  [disabled]="!data.displayHeader"
  class="expansion-panel-gap no-shadow">
  @if (data.displayHeader && data.sectionLabel) {
    <mat-expansion-panel-header class="section-header">
      {{ data.sectionLabel }}
    </mat-expansion-panel-header>
  }
  <div [ngClass]="{'section-body': data.displayHeader}" class="fx-layout-col">
    @if (empty) {
      <span class="empty-label">
        {{ data.sectionEmptyLabel || ('LABEL.EMPTY_SECTION' | translate) }}
      </span>
    }
    <ng-container fieldGroupAnchor></ng-container>
  </div>
</mat-expansion-panel>
